// 委託品入りのカートは Shop Pay（shop.app）に飛ばさず通常チェックアウトへ送る。
// shop.app では決済ルールアプリの「銀行振込のみ」が効かないため。
// 判定に失敗したときは通常どおり進める（すり抜けた注文はキャプチャ前にキャンセルする運用）。
//
// 商品ページの「購入手続きへ」（data-gt-buy-now のフォーム）もここで扱う。
// 一点物なのでカートは使わず、カートを空にしてその商品1点だけで購入画面へ進む。
(() => {
  let passthrough = false;

  const isBankOnlyCart = async () => {
    try {
      const response = await fetch(`${window.routes.cart_url}?view=gt-bank-only`, { cache: 'no-store' });
      return (await response.text()).trim() === 'true';
    } catch (e) {
      return false;
    }
  };

  const buyNow = async (form) => {
    const button = form.querySelector('[type="submit"]');
    const wrapper = form.closest('product-form');
    const errorWrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    const errorMessage = wrapper && wrapper.querySelector('.product-form__error-message');
    if (button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (errorWrapper) errorWrapper.toggleAttribute('hidden', true);

    try {
      await fetch(`${window.routes.cart_url}/clear.js`, { method: 'POST' });
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] }),
      });
      const result = await response.json();
      if (result.status) throw new Error(result.description || result.message);

      window.location.href = (await isBankOnlyCart()) ? '/checkout?skip_shop_pay=true' : '/checkout';
    } catch (e) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = e.message || '購入手続きに進めませんでした。時間をおいてもう一度お試しください。';
        errorWrapper.toggleAttribute('hidden', false);
      }
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (form.hasAttribute('data-gt-buy-now')) {
        event.preventDefault();
        event.stopPropagation();
        buyNow(form);
        return;
      }

      const submitter = event.submitter;
      if (passthrough || !submitter || submitter.name !== 'checkout') return;

      event.preventDefault();

      if (await isBankOnlyCart()) {
        window.location.href = '/checkout?skip_shop_pay=true';
        return;
      }

      passthrough = true;
      form.requestSubmit(submitter);
      passthrough = false;
    },
    true
  );
})();
